// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-settings-container__row {
  width: 100%;
  padding: 0 0 20px;
}
.color-settings-container__label {
  margin: 0 20px 0 32px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogColor/ColorSettingsContainer/ColorSettingsContainer.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,iBAAA;AAAR;AAGI;EACI,qBAAA;AADR","sourcesContent":[".color-settings-container__row {\n  width: 100%;\n  padding: 0 0 20px;\n}\n.color-settings-container__label {\n  margin: 0 20px 0 32px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
